<div class="profile-container">
    <div class="profile-header">
      <div class="profile-avatar">
        {{ firstName.charAt(0) }}{{ lastName.charAt(0) }}
      </div>
      <h1>{{ firstName }} {{ lastName }}</h1>
      <p class="profile-title">{{ company }}</p>
    </div>
    <div class="profile-content">
      <div class="profile-section">
        <h2>Personal Information</h2>
        <div class="profile-info">
          <div class="info-item">
            <span class="info-label">Email</span>
            <span class="info-value">{{ email }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Company</span>
            <span class="info-value">{{ company }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Business Area</span>
            <span class="info-value">{{ businessArea }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>